import { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// ── Icônes ───────────────────────────────────────────────────
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconArrow = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M19 12H5M12 5l-7 7 7 7"/>
  </svg>
);
const IconCalendar = ({ size = 15, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="4" width="18" height="18" rx="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);
const IconUsers = ({ size = 15, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);
const IconMoon = ({ size = 15, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);
const IconClock = ({ size = 48, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconCheck = ({ size = 16, color = "#3D6B2E" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconHome = ({ size = 15, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);
const IconMail  = ({ size = 18, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconPhone = ({ size = 18, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.95a16 16 0 0 0 6 6l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const IconFileText = ({ size = 18, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </svg>
);

// ── Étapes processus ──────────────────────────────────────────
const ETAPES = [
  { Icon: IconMail,     color: "#C4441A", titre: "Demande envoyée",       desc: "Votre demande est enregistrée et transmise à notre équipe." },
  { Icon: IconPhone,    color: "#C4441A", titre: "Vérification sous 24h", desc: "Nous vérifions la disponibilité et vous contactons par mail ou téléphone." },
  { Icon: IconFileText, color: "#C4441A", titre: "Envoi du contrat",      desc: "Si disponible, vous recevez un contrat de séjour à signer." },
  { Icon: IconCheck,    color: "#3D6B2E", titre: "Confirmation finale",   desc: "Votre réservation est confirmée après signature du contrat." },
];

export default function DemandeReservation() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { hebergement, reservation, nbNuits, total } = location.state || {};

  const [step, setStep]       = useState(1);
  const [loading, setLoading] = useState(false);
  const [form, setForm]       = useState({ nom: "", prenom: "", email: "", telephone: "", message: "" });

  const handle    = e => setForm({ ...form, [e.target.name]: e.target.value });
  const formatPrix = p => p?.toLocaleString("fr-FR") + " FCFA";
  const formatDate = d => d ? new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "";
  const isValid    = form.prenom && form.nom && form.email && form.telephone;

  const envoyerDemande = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch("https://senutour.com/api/reservations", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          hotelId:          hebergement.id,
          nomClient:        form.nom,
          prenomClient:     form.prenom,
          emailClient:      form.email,
          telephoneClient:  form.telephone,
          dateArrivee:      reservation.dateArrivee,
          dateDepart:       reservation.dateDepart,
          nbNuits,
          nbVoyageurs:      reservation.voyageurs,
          total,
          modePaiement:     "a_confirmer",
          message:          form.message,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setStep(2);
    } catch (error) {
      alert("Erreur : " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ── Garde : pas de state ──────────────────────────────────
  if (!hebergement) return (
    <div style={{ fontFamily: "'Fraunces',serif", background: "#FAF5EC", minHeight: "100vh" }}>
      <Navbar transparent={false} />
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "80vh", gap: 20 }}>
        <div style={{ fontSize: 56 }}>🏠</div>
        <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 700 }}>Aucune demande en cours</h2>
        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A" }}>
          Veuillez d'abord sélectionner un hébergement.
        </p>
        <button onClick={() => navigate("/hotels")} style={{ background: "#C4441A", color: "white", border: "none", padding: "12px 28px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
          Voir les hébergements
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily: "'Fraunces',serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin:0; padding:0; box-sizing:border-box; }

        .form-input {
          width: 100%; padding: 13px 16px;
          border: 1.5px solid #E8DCC8; border-radius: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          color: #1C1008; background: white; outline: none; transition: all .25s;
        }
        .form-input:focus { border-color: #C4441A; box-shadow: 0 0 0 3px rgba(196,68,26,.08); }
        .form-input::placeholder { color: #C4B8A8; }

        .btn-main {
          width: 100%; padding: 15px; background: #C4441A; color: white;
          border: none; border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 16px; font-weight: 700;
          cursor: pointer; transition: all .3s; display: flex; align-items: center; justify-content: center; gap: 10px;
        }
        .btn-main:hover:not(:disabled) { background: #A03614; transform: translateY(-2px); box-shadow: 0 8px 24px rgba(196,68,26,.3); }
        .btn-main:disabled { opacity: .5; cursor: not-allowed; transform: none; }

        .btn-back {
          width: 100%; padding: 13px; background: transparent; color: #7A5A3A;
          border: 1.5px solid rgba(28,16,8,.15); border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px; font-weight: 600;
          cursor: pointer; transition: all .3s;
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .btn-back:hover { border-color: #C4441A; color: #C4441A; }

        .recap-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }

        .label {
          font-family: 'Space Grotesk', sans-serif; font-size: 12px; font-weight: 700;
          color: #1C1008; display: block; margin-bottom: 7px;
          text-transform: uppercase; letter-spacing: 1px;
        }

        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner { animation: spin .8s linear infinite; display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.3); border-top-color: white; border-radius: 50%; }

        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .5s ease forwards; }

        @keyframes scaleIn { from { opacity:0; transform:scale(.9); } to { opacity:1; transform:scale(1); } }
        .scale-in { animation: scaleIn .5s ease forwards; }

        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.35} }
        .pulse-anim { animation: pulse 2s ease-in-out infinite; }

        @media(max-width:900px) { .resa-grid { grid-template-columns: 1fr !important; } }
        @media(max-width:767px) { .resa-pad { padding: 32px 5% 60px !important; } }
      `}</style>

      <Navbar transparent={false} />

      {/* ── BREADCRUMB ── */}
      <div style={{ paddingTop: 68, background: "white", borderBottom: "1px solid rgba(28,16,8,.07)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "14px 5%", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          {[
            { label: "Accueil",                action: () => navigate("/") },
            { label: "Hébergements",           action: () => navigate("/hotels") },
            { label: hebergement.nom,          action: () => navigate(`/hotels/${id}`) },
            { label: "Demande de réservation", action: null },
          ].map((b, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {i > 0 && <span style={{ color: "#B8A898" }}>›</span>}
              {b.action
                ? <button onClick={b.action} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>{b.label}</button>
                : <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#1C1008", fontWeight: 600 }}>{b.label}</span>
              }
            </div>
          ))}
        </div>
      </div>

      <section className="resa-pad" style={{ padding: "48px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>

          {/* ══════════════════════════════════════════════════
              ÉTAPE 2 — Confirmation envoyée
          ══════════════════════════════════════════════════ */}
          {step === 2 && (
            <div className="scale-in" style={{ textAlign: "center", padding: "60px 20px" }}>

              {/* Icône horloge */}
              <div style={{ display: "flex", justifyContent: "center", marginBottom: 28 }}>
                <div className="pulse-anim" style={{ width: 100, height: 100, borderRadius: "50%", background: "rgba(196,68,26,.08)", border: "2px dashed rgba(196,68,26,.3)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <IconClock size={52} color="#C4441A" />
                </div>
              </div>

              <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(26px,4vw,42px)", fontWeight: 800, marginBottom: 12, letterSpacing: "-1px" }}>
                Demande envoyée !
              </h1>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "#7A5A3A", maxWidth: 520, margin: "0 auto 8px", lineHeight: 1.7 }}>
                Votre demande pour <strong>{hebergement.nom}</strong> est en cours de vérification.
              </p>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#B8A898", maxWidth: 460, margin: "0 auto 40px" }}>
                Notre équipe vous contactera sous <strong style={{ color: "#C4441A" }}>24h</strong> au <strong>{form.telephone}</strong> ou à <strong>{form.email}</strong>.
              </p>

              {/* Processus */}
              <div style={{ background: "white", borderRadius: 16, padding: "28px", maxWidth: 560, margin: "0 auto 28px", border: "1.5px solid rgba(28,16,8,.08)", textAlign: "left" }}>
                <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 24 }}>Comment ça se passe ?</h3>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {ETAPES.map((e, i) => (
                    <div key={i} style={{ display: "flex", gap: 14, position: "relative" }}>
                      {i < ETAPES.length - 1 && (
                        <div style={{ position: "absolute", left: 15, top: 32, width: 2, height: "calc(100% - 8px)", background: i === 0 ? "#C4441A" : "rgba(196,68,26,.15)" }} />
                      )}
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: i === 0 ? "#C4441A" : "rgba(196,68,26,.1)", border: `2px solid ${i === 0 ? "#C4441A" : "rgba(196,68,26,.2)"}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, zIndex: 1 }}>
                        {i === 0
                          ? <div style={{ width: 8, height: 8, borderRadius: "50%", background: "white" }} />
                          : <e.Icon size={14} color={e.color} />
                        }
                      </div>
                      <div style={{ paddingBottom: i < ETAPES.length - 1 ? 24 : 0 }}>
                        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, color: i === 0 ? "#C4441A" : "#1C1008", marginBottom: 3 }}>{e.titre}</p>
                        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A", lineHeight: 1.5 }}>{e.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Récap */}
              <div style={{ background: "white", borderRadius: 16, padding: "24px", maxWidth: 460, margin: "0 auto 32px", border: "1.5px solid rgba(28,16,8,.08)", textAlign: "left" }}>
                <div style={{ display: "flex", gap: 14, alignItems: "center", marginBottom: 16, paddingBottom: 14, borderBottom: "1px solid rgba(28,16,8,.06)" }}>
                  <img src={hebergement.images[0]} alt={hebergement.nom} style={{ width: 68, height: 56, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
                  <div>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 700, marginBottom: 4 }}>{hebergement.nom}</h3>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <IconPin size={11} /><span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A" }}>{hebergement.ville}</span>
                    </div>
                  </div>
                </div>
                {[
                  { icon: <IconCalendar size={13} />, label: "Arrivée",    value: formatDate(reservation.dateArrivee) },
                  { icon: <IconCalendar size={13} />, label: "Départ",     value: formatDate(reservation.dateDepart) },
                  { icon: <IconMoon size={13} />,     label: "Durée",      value: `${nbNuits} nuit${nbNuits > 1 ? "s" : ""}` },
                  { icon: <IconUsers size={13} />,    label: "Voyageurs",  value: `${reservation.voyageurs} personne${reservation.voyageurs > 1 ? "s" : ""}` },
                ].map((r, i) => (
                  <div key={i} className="recap-row">
                    <span style={{ display: "flex", alignItems: "center", gap: 6, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>{r.icon}{r.label}</span>
                    <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.value}</span>
                  </div>
                ))}
                <div style={{ borderTop: "1px solid rgba(28,16,8,.06)", paddingTop: 12, marginTop: 4, display: "flex", justifyContent: "space-between" }}>
                  <span style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, color: "#7A5A3A" }}>Total estimé</span>
                  <span style={{ fontFamily: "'Fraunces',serif", fontSize: 17, fontWeight: 800, color: "#C4441A" }}>{formatPrix(total)}</span>
                </div>
                <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#B8A898", marginTop: 6 }}>* Le montant sera confirmé lors de la validation</p>
              </div>

              <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                <button className="btn-main" style={{ maxWidth: 220 }} onClick={() => navigate("/profil")}>
                  Suivre mes demandes
                </button>
                <button onClick={() => navigate("/")} style={{ display: "flex", alignItems: "center", gap: 8, background: "transparent", border: "1.5px solid rgba(28,16,8,.2)", color: "#1C1008", padding: "14px 24px", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                  <IconHome size={14} color="#1C1008" /> Accueil
                </button>
              </div>
            </div>
          )}

          {/* ══════════════════════════════════════════════════
              ÉTAPE 1 — Formulaire
          ══════════════════════════════════════════════════ */}
          {step === 1 && (
            <div className="resa-grid fade-up" style={{ display: "grid", gridTemplateColumns: "1fr 360px", gap: 32, alignItems: "start" }}>

              {/* ── GAUCHE ── */}
              <div>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, marginBottom: 8 }}>
                  Votre demande de réservation
                </h2>
                <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 28, lineHeight: 1.6 }}>
                  Renseignez vos informations. Notre équipe vous contactera sous 24h pour confirmer la disponibilité.
                </p>

                {/* Formulaire */}
                <div style={{ background: "white", borderRadius: 14, padding: "28px", border: "1.5px solid rgba(28,16,8,.06)", marginBottom: 20 }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 22 }}>Vos informations</h3>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
                    <div>
                      <label className="label">Prénom *</label>
                      <input className="form-input" name="prenom" placeholder="Amina" value={form.prenom} onChange={handle} />
                    </div>
                    <div>
                      <label className="label">Nom *</label>
                      <input className="form-input" name="nom" placeholder="Diallo" value={form.nom} onChange={handle} />
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <label className="label">Email *</label>
                    <input className="form-input" type="email" name="email" placeholder="votre@email.com" value={form.email} onChange={handle} />
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#B8A898", marginTop: 5 }}>
                      La confirmation et le contrat de séjour seront envoyés à cette adresse.
                    </p>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <label className="label">Téléphone *</label>
                    <input className="form-input" name="telephone" placeholder="+221 77 000 00 00" value={form.telephone} onChange={handle} />
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#B8A898", marginTop: 5 }}>
                      Notre équipe peut vous appeler sur ce numéro pour confirmer votre séjour.
                    </p>
                  </div>

                  <div>
                    <label className="label">Message (optionnel)</label>
                    <textarea className="form-input" name="message" placeholder="Heure d'arrivée, besoins particuliers, animaux..." value={form.message} onChange={handle} rows={4} style={{ resize: "vertical" }} />
                  </div>
                </div>

                {/* Info processus */}
                <div style={{ background: "rgba(196,68,26,.04)", borderRadius: 12, padding: "20px 22px", border: "1.5px solid rgba(196,68,26,.12)", marginBottom: 20 }}>
                  <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, color: "#C4441A", marginBottom: 14, textTransform: "uppercase", letterSpacing: 1 }}>
                    Ce qui se passe après votre demande
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {[
                      "Notre équipe vérifie la disponibilité de l'hébergement",
                      "Vous êtes contacté(e) sous 24h par email ou téléphone",
                      "Si disponible, un contrat de séjour vous est envoyé",
                      "Après signature, votre réservation est officiellement confirmée",
                    ].map((t, i) => (
                      <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                        <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#C4441A", color: "white", fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>{i + 1}</div>
                        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A", lineHeight: 1.5 }}>{t}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="btn-main" disabled={!isValid || loading} onClick={envoyerDemande}>
                  {loading
                    ? <><span className="spinner" /> Envoi en cours...</>
                    : "Envoyer ma demande de réservation →"
                  }
                </button>
                <button className="btn-back" style={{ marginTop: 10 }} onClick={() => navigate(`/hotels/${id}`)}>
                  <IconArrow size={14} /> Retour à l'hébergement
                </button>
              </div>

              {/* ── DROITE — Récap sticky ── */}
              <div style={{ position: "sticky", top: 88 }}>
                <div style={{ background: "white", borderRadius: 16, padding: "24px", border: "1.5px solid rgba(28,16,8,.08)", boxShadow: "0 4px 20px rgba(28,16,8,.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 700, marginBottom: 18 }}>Récapitulatif</h3>

                  <div style={{ display: "flex", gap: 12, marginBottom: 18, paddingBottom: 16, borderBottom: "1px solid rgba(28,16,8,.06)" }}>
                    <img src={hebergement.images[0]} alt={hebergement.nom} style={{ width: 68, height: 56, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
                    <div>
                      <h4 style={{ fontFamily: "'Fraunces',serif", fontSize: 15, fontWeight: 700, marginBottom: 4, lineHeight: 1.3 }}>{hebergement.nom}</h4>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <IconPin size={11} /><span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#7A5A3A" }}>{hebergement.ville}</span>
                      </div>
                    </div>
                  </div>

                  {[
                    { icon: <IconCalendar size={12} />, label: "Arrivée",   value: formatDate(reservation.dateArrivee) },
                    { icon: <IconCalendar size={12} />, label: "Départ",    value: formatDate(reservation.dateDepart) },
                    { icon: <IconMoon size={12} />,     label: "Durée",     value: `${nbNuits} nuit${nbNuits > 1 ? "s" : ""}` },
                    { icon: <IconUsers size={12} />,    label: "Voyageurs", value: `${reservation.voyageurs}` },
                  ].map((r, i) => (
                    <div key={i} className="recap-row">
                      <span style={{ display: "flex", alignItems: "center", gap: 5, fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>{r.icon}{r.label}</span>
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600, color: "#1C1008" }}>{r.value}</span>
                    </div>
                  ))}

                  <div style={{ borderTop: "1px solid rgba(28,16,8,.06)", paddingTop: 14, marginTop: 4 }}>
                    <div className="recap-row">
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A" }}>
                        {hebergement.prix?.toLocaleString("fr-FR")} FCFA × {nbNuits} nuit{nbNuits > 1 ? "s" : ""}
                      </span>
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 600 }}>{formatPrix(total)}</span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderTop: "1px solid rgba(28,16,8,.06)" }}>
                      <span style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 700, color: "#7A5A3A" }}>Total estimé</span>
                      <span style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#C4441A" }}>{formatPrix(total)}</span>
                    </div>
                  </div>

                  <div style={{ background: "rgba(196,68,26,.04)", borderRadius: 8, padding: "12px 14px" }}>
                    {["Vérification sous 24h", "Contrat envoyé par email", "Confirmation après signature"].map((t, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: i < 2 ? 6 : 0 }}>
                        <IconCheck size={12} color="#C4441A" />
                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#C4441A" }}>{t}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}